<template>
<div class="chapter">
<div class="inner_page">
<h1 class="toc-title">CONTENTS</h1>
<p class="toc"><a href="#/introduction">INTRODUCTION</a></p>
<p class="toc"><a href="#/chapter001">DAVID’S WORM</a></p>
<p class="toc"><a href="#/chapter002">DAGON’S BELL </a></p>
<p class="toc"><span href="#/chapter003" title="Link target outside of Sample">THE SUN, THE SEA, AND THE SILENT SCREAM</span></p>
<p class="toc"><span href="#/chapter004" title="Link target outside of Sample">THE SECOND WISH</span></p>
<p class="toc"><span href="#/chapter005" title="Link target outside of Sample">A <em>THING</em> ABOUT CARS!</span></p>
<p class="toc"><span href="#/chapter006" title="Link target outside of Sample">RISING WITH SURTSEY</span></p>
<p class="toc"><span href="#/chapter007" title="Link target outside of Sample">BIG ’C’ </span></p>
<p class="toc"><span href="#/chapter008" title="Link target outside of Sample">THE FAIRGROUND HORROR</span></p>
<p class="toc"><span href="#/chapter009" title="Link target outside of Sample">BENEATH THE MOORS</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?50fb5a7e